<ais-instantsearch class="asw-container" [config]="config">
  @if (isTeacher) {
    <section-label
      class="section-label"
      [sectionLabelContent]="searchSectionLabel"
      [alignCenter]="true"
      [isTeacher]="isTeacher"
    ></section-label>
  }
  @if (isTeacher) {
    <span
      class="create-content-description sub-title font-size-12px"
      [ngClass]="{ white: !isTeacher }"
      >Search by keyword{{ mathTypesDescription }}</span
      >
    }
    <ais-configure [searchParameters]="searchParameters"></ais-configure>
    <!-- <ais-search-box
    #aisSearchBox
    (input)="onSearch($event)"
    (reset)="onSearch($event)"
    placeholder="Search"
  ></ais-search-box> -->
  @if (isTeacher) {
    <div class="search-container-teacher">
      <input
        #algo_search_input
        class="search-container-teacher-input"
        [placeholder]="placeholderText"
        type="text"
        [value]="searchInput"
        (keyup)="onSearch($event)"
        />
      @if (searchInput.length) {
        <button
          class="search-container-teacher__button search-container-teacher__cancel"
          (click)="onSearch($event)"
          >
          <mat-icon>close</mat-icon>
        </button>
      }
      @if (!searchInput.length) {
        <button
          class="search-container-teacher__button"
          >
          <mat-icon>search</mat-icon>
        </button>
      }
    </div>
  }
  @if (isStudent) {
    <div class="search-container-student">
      <div class="search-field-inputs">
        <input
          #algo_search_input
          class="search-container-input"
          [placeholder]="placeholderText"
          matInput
          aria-label="Search"
          type="text"
          [value]="searchInput"
          (keyup)="onSearch($event)"
          />
      </div>
      @if (!searchInput.length) {
        <mat-icon
          aria-label="Search"
          matPrefix
          class="searchIcon"
          >
          search</mat-icon
          >
        }
        @if (searchInput.length) {
          <mat-icon
            matPrefix
            class="searchIcon cursor-pointer"
            aria-label="Clear"
            (click)="onSearch($event)"
            >close</mat-icon
            >
          }
        </div>
      }
    </ais-instantsearch>
